import axios from 'axios';
import { getAuth } from 'firebase/auth';
import firebase from '../firebase/Firebase';

const auth = getAuth(firebase)
const getIdToken = () => {
  return new Promise((resolve) => {
    const user = auth.currentUser;
    if (user) {
      user.getIdToken(true).then((idToken) => {
        resolve(idToken);
      });
    } else {
      resolve(null);
    }
  })
};

export const shopixios = axios.create();
shopixios.interceptors.request.use((config) => {
  return config;
});

export const apixios = axios.create();
apixios.interceptors.request.use(async (config) => {
  const idToken = await getIdToken()
  config.headers.Authorization = `Bearer ${idToken}`;
  config.headers['CacheControl'] = "no-cache";

  return config;
});
